module.exports = __webpack_public_path__ + "static/media/S2N10-5.2c9f8ff3.svg";